'use client';

import { createContext, useContext } from 'react';
import { SettingsProvider } from '@/contexts/SettingsContext';
import type { ShareableState } from '@/lib/share-utils';

interface ShareModeProviderProps {
  children: React.ReactNode;
  shareData: ShareableState;
}

interface ShareModeContextType {
  isShareMode: boolean;
  shareData: ShareableState;
}

const ShareModeContext = createContext<ShareModeContextType | null>(null);

/**
 * Provider that locks context values to the shared configuration
 * Prevents any changes to currency or pricing settings
 */
export function ShareModeProvider({ children, shareData }: ShareModeProviderProps) {
  return (
    <ShareModeContext.Provider value={{ isShareMode: true, shareData }}>
      <SettingsProvider>
        {children}
      </SettingsProvider>
    </ShareModeContext.Provider>
  );
}

/**
 * Hook to check if we're in share mode and get share data
 */
export function useShareMode() {
  const context = useContext(ShareModeContext);
  return context || { isShareMode: false, shareData: null };
}